import ClickRedirect from '@/directives/clickRedirect/clickRedirect';
import RequiresPermission from './requiresPermission';
import Trigger from './trigger/trigger';

export default {
  install(Vue) {
    Vue.use(RequiresPermission);
    Vue.use(Trigger);
    Vue.use(ClickRedirect);
  },
};
